import { Text, Flex, Box } from '@chakra-ui/react';
import { CloseIcon } from '@halo/ui-chat-react';

function GroupJoinRequest({
  joinRequestCount,
  onHandle,
  onClose,
}: {
  joinRequestCount: number;
  onHandle: () => void;
  onClose: () => void;
}) {
  return (
    <Flex
      bg="linear-gradient(0deg, var(--colors-brand-10, rgba(129, 55, 255, 0.10)) 0%, var(--colors-brand-10, rgba(129, 55, 255, 0.10)) 100%), var(--colors-white, #FFF)"
      p="3"
      lineHeight="normal"
      align="center"
      justifyContent="space-between"
    >
      <Box w="16px" h="16px" />
      <Flex gap="2" fontSize="sm">
        <Text fontWeight="medium">Join request ({joinRequestCount})</Text>
        <Text
          color="brand"
          textDecoration="underline"
          fontWeight="bold"
          cursor="pointer"
          onClick={onHandle}
        >
          Handle
        </Text>
      </Flex>
      <Box onClick={onClose} cursor="pointer">
        <CloseIcon />
      </Box>
    </Flex>
  );
}

const MemoizedGroupJoinRequest = memo(GroupJoinRequest);
export { MemoizedGroupJoinRequest as GroupJoinRequest };
